import { render, staticRenderFns } from "./RegistrationTermsConditionsForm.vue?vue&type=template&id=7622f0ec&scoped=true&"
import script from "./RegistrationTermsConditionsForm.vue?vue&type=script&lang=js&"
export * from "./RegistrationTermsConditionsForm.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationTermsConditionsForm.vue?vue&type=style&index=0&id=7622f0ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7622f0ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCheckbox,VCol,VForm,VRow})
